(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var overlay = document.getElementById('pdp360Overlay');
    if (!overlay) return;

    var modal = overlay.querySelector('.pdp360-modal');
    var modelViewer = document.getElementById('pdp360ModelViewer');
    var closeBtn = overlay.querySelector('.pdp360-close');
    var toggleCard = document.getElementById('pdp360ReclineToggle');
    var toggleInput = document.getElementById('pdp360ReclineInput');
    var toggleTitle = document.getElementById('pdp360ToggleTitle');
    var toggleSubtitle = document.getElementById('pdp360ToggleSubtitle');
    var loadingEl = document.getElementById('pdp360Loading');
    var loadingTextEl = document.getElementById('pdp360LoadingText');

    if (!modelViewer || !toggleInput || !toggleCard) return;

    var rafId = null;
    var loadingIntervalId = null;
    var loadingTimeoutId = null;
    var toggleExtraHeight = 0;

    var currentUrl = '';
    var loadedUrl = '';
    var animationDuration = 0;
    var animationReady = false;

    var loadingMessages = [
      'Building your view',
      'Assembling the parts',
      'Warming up the recliner',
      'Fluffing the cushions',
      'Almost there'
    ];

    var loadingIndex = 0;

    /* -------------------------
       LOADING
    ------------------------- */

    function startLoadingText() {
      stopLoadingText();

      loadingIndex = 0;

      if (loadingTextEl) {
        loadingTextEl.textContent =
          loadingMessages[0] + '...';
        loadingTextEl.classList.remove('fade');
      }

      if (loadingEl) {
        loadingEl.classList.remove('hidden');
      }

      loadingIntervalId = setInterval(function () {
        loadingIndex =
          (loadingIndex + 1) %
          loadingMessages.length;

        if (!loadingTextEl) return;

        loadingTextEl.classList.add('fade');

        loadingTimeoutId = setTimeout(function () {
          loadingTextEl.textContent =
            loadingMessages[loadingIndex] + '...';

          loadingTextEl.classList.remove('fade');
        }, 250);
      }, 1000);
    }

    function stopLoadingText() {
      clearInterval(loadingIntervalId);
      clearTimeout(loadingTimeoutId);

      loadingIntervalId = null;
      loadingTimeoutId = null;

      if (loadingEl) {
        loadingEl.classList.add('hidden');
      }
    }

    /* -------------------------
       ANIMATION
    ------------------------- */

    function stopScrub() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    function resetAnimation() {
      stopScrub();

      animationReady = false;
      animationDuration = 0;

      toggleInput.checked = false;
      toggleCard.classList.add('hidden');

      try {
        modelViewer.pause();
        modelViewer.currentTime = 0;
      } catch (error) {}

      try {
        modelViewer.animationName = '';
      } catch (error) {}
    }

    function initializeAnimation(expectedUrl) {
    // Prevent stale variant initialization
    if (
      expectedUrl &&
      currentUrl !== expectedUrl
    ) {
      return;
    }

    var attempts = 0;
    var maxAttempts = 40;

    animationReady = false;
    animationDuration = 0;

    toggleInput.checked = false;
    toggleCard.classList.add('hidden');

    function findAnimation() {
      attempts++;

      // Popup closed or variant changed
      if (
        !overlay.classList.contains('active') ||
        (
          expectedUrl &&
          currentUrl !== expectedUrl
        )
      ) {
        return;
      }

      var animations =
        modelViewer.availableAnimations || [];

      if (animations.length > 0) {
        var animationName = animations[0];

        try {
          modelViewer.animationName =
            animationName;

          modelViewer.pause();

          // Reset to normal position
          modelViewer.currentTime = 0;
        } catch (error) {
          console.error(
            'Animation setup error:',
            error
          );
        }

        waitForDuration(
          animationName,
          expectedUrl
        );

        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(findAnimation, 100);
      } else {
        console.warn(
          'No recliner animation found for:',
          expectedUrl
        );

        toggleCard.classList.add('hidden');
      }
    }

      function waitForDuration(
        animationName,
        url
      ) {
        var durationAttempts = 0;
        var maxDurationAttempts = 50;

        function checkDuration() {
          durationAttempts++;

          // Stop if variant changed
          if (
            !overlay.classList.contains('active') ||
            currentUrl !== url
          ) {
            return;
          }

          var duration =
            Number(modelViewer.duration) || 0;

          if (duration > 0) {
            animationDuration = duration;
            animationReady = true;

            try {
              modelViewer.pause();
              modelViewer.currentTime = 0;
            } catch (error) {}

            // Show toggle
            toggleInput.checked = false;
            toggleCard.classList.remove('hidden');

            toggleExtraHeight = 75;

            sizeModalToSlide();

            console.log(
              'Recliner animation ready for variant:',
              url
            );

            return;
          }

          if (
            durationAttempts <
            maxDurationAttempts
          ) {
            setTimeout(checkDuration, 50);
          } else {
            console.warn(
              'Animation found but duration unavailable:',
              animationName
            );

            /*
            * Still show toggle if animation exists.
            * Duration may become available later.
            */
            toggleCard.classList.remove('hidden');

            toggleExtraHeight = 75;
            sizeModalToSlide();
          }
        }

        requestAnimationFrame(checkDuration);
      }

      findAnimation();
    }

    function setupAnimation(animations) {
      if (
        !overlay.classList.contains('active') ||
        !animations ||
        !animations.length
      ) {
        return;
      }

      var animationName = animations[0];

      animationReady = false;
      animationDuration = 0;

      try {
        modelViewer.animationName = animationName;
        modelViewer.pause();
        modelViewer.currentTime = 0;
      } catch (error) {
        console.error(
          'Animation initialization error:',
          error
        );
        return;
      }

      /*
      * Wait until duration becomes available.
      */
      var attempts = 0;
      var maxAttempts = 50;

      function waitForAnimation() {
        attempts++;

        if (!overlay.classList.contains('active')) {
          return;
        }

        var duration =
          Number(modelViewer.duration) || 0;

        if (duration > 0) {
          animationDuration = duration;
          animationReady = true;

          try {
            modelViewer.pause();
            modelViewer.currentTime = 0;
          } catch (error) {}

          toggleInput.checked = false;

          // SHOW TOGGLE
          toggleCard.classList.remove('hidden');

          toggleExtraHeight = 75;

          sizeModalToSlide();

          console.log(
            'Recliner animation ready:',
            animationName,
            animationDuration
          );

          return;
        }

        if (attempts < maxAttempts) {
          setTimeout(
            waitForAnimation,
            50
          );
        } else {
          console.warn(
            'Animation duration not available'
          );

          // Don't keep it hidden forever if animation exists
          if (
            modelViewer.availableAnimations &&
            modelViewer.availableAnimations.length
          ) {
            toggleCard.classList.remove('hidden');
          }
        }
      }

      requestAnimationFrame(waitForAnimation);
    }

    function scrubTo(target) {
      stopScrub();

      if (!animationReady) {
        console.warn(
          'Recline animation is not ready'
        );
        return;
      }

      var duration =
        animationDuration ||
        Number(modelViewer.duration) ||
        0;

      if (!duration) return;

      target = Math.max(
        0,
        Math.min(target, duration)
      );

      try {
        modelViewer.pause();
      } catch (error) {}

      var startTime = null;

      var startValue =
        Number(modelViewer.currentTime) || 0;

      var difference =
        target - startValue;

      var scrubDuration = 2500;

      function frame(now) {
        if (startTime === null) {
          startTime = now;
        }

        var progress = Math.min(
          (now - startTime) /
            scrubDuration,
          1
        );

        var eased =
          progress < 0.5
            ? 2 * progress * progress
            : 1 -
              Math.pow(
                -2 * progress + 2,
                2
              ) / 2;

        try {
          modelViewer.currentTime =
            startValue +
            difference * eased;
        } catch (error) {
          rafId = null;
          return;
        }

        if (progress < 1) {
          rafId =
            requestAnimationFrame(frame);
        } else {
          modelViewer.currentTime =
            target;

          rafId = null;
        }
      }

      rafId =
        requestAnimationFrame(frame);
    }

    /* -------------------------
       MODEL EVENTS
    ------------------------- */

    function onModelLoad() {
      if (!overlay.classList.contains('active')) {
        return;
      }

      var activeSrc =
        modelViewer.getAttribute('src') || '';

      /*
      * Ignore stale load events from
      * a previously selected variant.
      */
      if (
        !currentUrl ||
        activeSrc !== currentUrl
      ) {
        return;
      }

      loadedUrl = currentUrl;

      stopLoadingText();

      // Wait briefly for animations to be available
      setTimeout(function () {
        if (
          overlay.classList.contains('active') &&
          loadedUrl === currentUrl
        ) {
          initializeAnimation(currentUrl);
        }
      }, 100);
    }

    function onModelError() {
      stopLoadingText();

      console.error(
        '360 model failed to load:',
        currentUrl
      );
    }

    modelViewer.addEventListener(
      'load',
      onModelLoad
    );

    modelViewer.addEventListener(
      'error',
      onModelError
    );

    /* -------------------------
       MODAL SIZE
    ------------------------- */

    function sizeModalToSlide() {
      if (!modal) return;

      var slide = document.querySelector(
        '.pdp-gallery-mobile'
      );

      var rect = slide
        ? slide.getBoundingClientRect()
        : null;

      var width;
      var height;

      if (
        rect &&
        rect.width &&
        rect.height
      ) {
        width = rect.width;

        height =
          rect.height +
          toggleExtraHeight;
      } else {
        width = Math.min(
          window.innerWidth * 0.9,
          480
        );

        height =
          Math.min(
            window.innerHeight * 0.7,
            640
          ) +
          toggleExtraHeight;
      }

      height = Math.min(
        height,
        window.innerHeight * 0.95
      );

      modal.style.width =
        width + 'px';

      modal.style.height =
        height + 'px';

      modal.style.top =
        Math.max(
          0,
          (window.innerHeight - height) / 2
        ) + 'px';

      modal.style.left = '0';
      modal.style.right = '0';
      modal.style.marginLeft = 'auto';
      modal.style.marginRight = 'auto';
    }

    /* -------------------------
       LOAD / OPEN
    ------------------------- */

    function prepareExistingModel() {
      stopScrub();

      animationReady = false;
      animationDuration = 0;

      toggleInput.checked = false;
      toggleCard.classList.add('hidden');

      try {
        modelViewer.pause();

        if (
          modelViewer.availableAnimations &&
          modelViewer.availableAnimations.length
        ) {
          modelViewer.animationName =
            modelViewer.availableAnimations[0];
        }

        modelViewer.currentTime = 0;
      } catch (error) {}
    }

    function loadModel(url) {
      if (!url) return;

      currentUrl = url;

      // Reset state for every popup open
      stopScrub();

      animationReady = false;
      animationDuration = 0;
      toggleInput.checked = false;
      toggleCard.classList.add('hidden');
      toggleExtraHeight = 0;

      var currentSrc =
        modelViewer.getAttribute('src') || '';

      /*
      * Same variant/model:
      * Reuse the already loaded model.
      */
      if (
        loadedUrl === url &&
        currentSrc === url
      ) {
        requestAnimationFrame(function () {
          if (
            overlay.classList.contains('active') &&
            currentUrl === url
          ) {
            initializeAnimation(url);
          }
        });

        return;
      }

      /*
      * Variant changed / New model:
      * Force model-viewer to load the new GLB.
      */
      loadedUrl = '';

      startLoadingText();

      try {
        modelViewer.pause();
        modelViewer.currentTime = 0;
        modelViewer.animationName = '';
      } catch (error) {}

      // Remove old model first
      modelViewer.removeAttribute('src');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          // Important: ignore if variant changed again
          if (
            !overlay.classList.contains('active') ||
            currentUrl !== url
          ) {
            return;
          }

          modelViewer.setAttribute('src', url);
        });
      });
    }

    function openPopup(thumb) {
      var url =
        thumb.getAttribute(
          'data-360-url'
        ) || '';

      if (!url) return;

      toggleTitle.textContent =
        thumb.getAttribute(
          'data-360-toggle-title'
        ) ||
        'Recline View';

      toggleSubtitle.textContent =
        thumb.getAttribute(
          'data-360-toggle-subtitle'
        ) ||
        'Show in reclined position';

      toggleExtraHeight = 0;

      overlay.classList.add('active');

      document.body.style.overflow =
        'hidden';

      sizeModalToSlide();

      loadModel(url);
    }

    /* -------------------------
       CLOSE
    ------------------------- */

    function closePopup() {
      stopScrub();
      stopLoadingText();

      overlay.classList.remove('active');
      document.body.style.overflow = '';

      try {
        modelViewer.pause();
        modelViewer.currentTime = 0;
      } catch (error) {}

      toggleInput.checked = false;

      // Reset animation state
      animationReady = false;
      animationDuration = 0;

      // Hide while popup is closed
      toggleCard.classList.add('hidden');

      toggleExtraHeight = 0;

      gaEvent(
        '360_view_cancelled',
        ['', '', '', '', '', ''],
        false
      );
    }

    /* -------------------------
       EVENTS
    ------------------------- */

    document.addEventListener(
      'click',
      function (e) {
        var thumb =
          e.target.closest &&
          e.target.closest(
            '.pdp-360-thumb'
          );

        if (!thumb) return;

        e.preventDefault();
        e.stopPropagation();

        var productTitle =
          document.querySelector(
            '.product-title'
          );

        var selectedVariant =
          document.querySelector(
            '.v2_selected_variant'
          );

        var variantValue =
          selectedVariant
            ? selectedVariant
                .textContent
                .trim()
            : '';

        var productTitleValue =
          productTitle
            ? productTitle
                .textContent
                .trim()
            : '';

        gaEvent(
          '360_view_click',
          [
            variantValue,
            '',
            '',
            '',
            productTitleValue,
            ''
          ],
          false
        );

        openPopup(thumb);
      }
    );

    closeBtn.addEventListener(
      'click',
      closePopup
    );

    overlay.addEventListener(
      'click',
      function (e) {
        if (e.target === overlay) {
          closePopup();
        }
      }
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (
          e.key === 'Escape' &&
          overlay.classList.contains(
            'active'
          )
        ) {
          closePopup();
        }
      }
    );

    toggleInput.addEventListener(
      'change',
      function () {
        if (!animationReady) {
          this.checked = false;
          return;
        }

        var duration =
          animationDuration ||
          Number(modelViewer.duration) ||
          0;

        if (!duration) {
          this.checked = false;
          return;
        }

        scrubTo(
          this.checked
            ? duration
            : 0
        );

        gaEvent(
          '360_toggle',
          [
            '',
            this.checked
              ? 'on'
              : 'off',
            '',
            '',
            '',
            ''
          ],
          false
        );
      }
    );

    window.addEventListener(
      'resize',
      function () {
        if (
          overlay.classList.contains(
            'active'
          )
        ) {
          sizeModalToSlide();
        }
      }
    );
  });
})();